/**
 * Remembers the previous in-app route so `PageBack` can tell whether going
 * "up" is the same as going back in history (restoring scroll, filters, tabs).
 */
let previous = null

/** Called from `router.afterEach`. */
export function trackRoute(from) {
  previous = from && from.name ? { name: from.name, params: { ...from.params } } : null
}

/** True when the previous in-app route matches the given route location. */
export function previousMatches(location, router) {
  if (!previous || !location) return false
  const target = router.resolve(location).route
  if (target.name !== previous.name) return false
  return JSON.stringify(target.params) === JSON.stringify(previous.params)
}

/** True for same-origin paths only ("/x", never "//host" or "http://…"). */
export function isSafeRedirect(path) {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')
}
